namespace app.services.terms {
  export class SearchTermListService implements IService {
    private readonly ItemResource;

    constructor($resource: angular.resource.IResourceService, configService: app.services.IConfigService, resourceWrapperService: app.services.utilities.ResourceWrapperService) {
      const searchTermListResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/searchtermlist/:id`,
        {'id': '@id', 'projectId': '@projectId'},
        {
          'update': {method: "PUT"},
          'query': {method: "GET", isArray: false}
        }
      );
      this.ItemResource = resourceWrapperService.WrapActions(searchTermListResource);
    }

    public async FindOne(id: string, projectId: string) {
      return this.ItemResource.get({id: id, projectId: projectId}).$promise;
    }

    public async FindAll(projectId: string) {
      return this.ItemResource.query({
        projectId: projectId,
      }).$promise;
    }

    public Create(projectId: string, name: string, terms: string[]) {
      return new this.ItemResource({
        projectId: projectId,
        name: name,
        terms: terms
      });
    };

    public Save(newSearchTermList, callback, errorCallback) {
      return newSearchTermList.$save(searchTermList => callback?.call(this, searchTermList), response => errorCallback?.call(this, response.data));
    };

  }

  frontendApp.factory("SearchTermListService", ['$resource', 'ConfigService', 'ResourceWrapperService', function(resource, configService, resourceWrapperService) {
    return new SearchTermListService(resource, configService, resourceWrapperService);
  }]);
}
